<template>
  <transition name="fade" appear>
    <div class="c-popup" v-if="modal">
      <div class="c-popup__bg"></div>
      <div class="c-popup__inner">
        <div class="closeLayer"></div>
        <div class="c-popup-body">
          <div class="c-popup-body__inner">
            <div class="c-popup-body__main">
              <div class="c-popup-body__head">
                <p class="c-popup-body__head-title">
                  {{ modal.title }}
                </p>
              </div>
              <div class="c-popup-body__titleBox">
                <div class="c-popup-body__titleBox-text">
                  <div class="c-popup__attention">
                    <p v-html="modal.text"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-popup-body__footer">
              <div class="btnBlock -single">
                <button type="button" class="c-button-blue -full" @click="closeModal">
                  <span class="label">戻る</span>
                </button>
              </div>
            </div>
            <span class="c-popup-body__close" @click="closeModal">
              <span class="c-popup-body__close-inner"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
  import {onMounted, computed} from "vue";
  import { useErrorStore } from "@/store/teacher/error_store";

  const errorStore = useErrorStore()
  const emit = defineEmits<{
    (e: 'close'): void
  }>()

  const modal = computed(() => {
    const body = document.body
    if (errorStore.getTeacherError) {
      // モーダルが開いたとき背景をスクロールした位置で固定にしてスクロールできないようする。
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
      body.style.position = 'fixed'
      body.style.top = `-${scrollY}`
    } else {
      nonModal()
    }
    return errorStore.getTeacherError
  })

  onMounted(() => {
    window.addEventListener('scroll', () => {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`)
    })
  })

  function nonModal() {
    const body = document.body
    const scrollY = body.style.top
    body.style.position = ''
    body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
  }

  function closeModal() {
    errorStore.saveTeacherError(null)
    nonModal()
    emit("close")
  }
</script>

<style lang="scss" scoped>
.c-popup {
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .7s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
